import React from 'react';
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, Legend, ResponsiveContainer 
} from 'recharts';
import { BarChart3, Loader2 } from 'lucide-react';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-borderColor p-3 rounded-xl shadow-lg min-w-[180px]">
        <p className="text-xs font-bold text-text mb-2 border-b border-borderColor pb-2">
          {label}
        </p>
        <div className="flex flex-col gap-1.5">
          {payload.map((entry: any, index: number) => (
            <div key={index} className="flex items-center justify-between text-xs font-semibold">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.color }} />
                <span className="text-text/70">{entry.name}:</span>
              </div>
              <span className="text-text font-bold">{entry.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

export const StaffPerformanceChart: React.FC<any> = ({ data, loading }) => {
  return (
    <div className="flex flex-col p-4 bg-card rounded-2xl border border-borderColor shadow-sm w-full h-[400px]">
      
      {/* BAŞLIK */}
      <div className="flex items-center gap-2 mb-6">
        <div className="p-2 rounded-xl bg-primary/10 text-primary">
          <BarChart3 size={18} />
        </div>
        <h3 className="font-bold text-sm text-text uppercase tracking-wider">
          Personel Performans Analizi
        </h3>
        {loading && <Loader2 size={16} className="animate-spin text-primary ml-auto" />}
      </div>

      {/* GRAFİK */}
      <div className="relative flex-1 w-full h-full">
        {data && data.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 5, right: 0, left: -25, bottom: 0 }}
              barGap={4}
            >
              <CartesianGrid 
                strokeDasharray="3 3" 
                vertical={false} 
                stroke="var(--border)" 
                opacity={0.4}
              />
              <XAxis 
                dataKey="name" 
                axisLine={false} 
                tickLine={false} 
                tick={{ fill: 'var(--text)', fontSize: 11, opacity: 0.7 }}
                dy={10}
              />
              <YAxis 
                axisLine={false} 
                tickLine={false} 
                tick={{ fill: 'var(--text)', fontSize: 11, opacity: 0.7 }}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--border)', opacity: 0.1 }} />
              <Legend iconType="circle" wrapperStyle={{ fontSize: '12px', fontWeight: 500, paddingTop: '10px' }} />

              <Bar dataKey="pickingDoneCount" name="Toplanan" fill="var(--primary)" radius={[4, 4, 0, 0]} maxBarSize={40} />
              <Bar dataKey="packagingDoneCount" name="Paketlenen" fill="var(--secondary)" radius={[4, 4, 0, 0]} maxBarSize={40} />
              <Bar dataKey="shortageReportedCount" name="Eksik" fill="var(--danger)" radius={[4, 4, 0, 0]} maxBarSize={40} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex items-center justify-center w-full h-full text-text/40 text-sm">
            {loading ? 'Veriler yükleniyor...' : 'Veri bulunamadı.'}
          </div>
        )}
      </div>
    </div>
  );
};